/* src/app/components/companies-components/companies-companies-list-card/companies-companies-list-card.component.scss */
.list-card header > div {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
}
@media (max-width: 768px) {
  .list-card header > div {
    align-items: stretch;
  }
  .list-card header > div > app-mb-button {
    width: 100%;
  }
  th.sortable {
    cursor: pointer;
    -webkit-user-select: none;
    user-select: none;
    white-space: nowrap;
  }
  th.sortable > span {
    font-size: 1.1rem;
    opacity: 0.75;
    margin-left: 0.35rem;
  }
}
/*# sourceMappingURL=companies-companies-list-card.component.css.map */
